import axios, { microServices } from './axios'
import { loaders } from './../constants'

const BASE = '/work-hour-setting'

export const getWorkHourSettingsAPI = async () => {
    return await axios('get', BASE, {}, { loader: loaders.OVERLAY, server: microServices.DE_CORE })
        .then(data => data, error => Promise.reject(error))
}

export const getWorkHourSettingAPI = async (id) => {
    return await axios('get', `${BASE}/${id}`, {}, { loader: loaders.OVERLAY, server: microServices.DE_CORE })
        .then(data => data, error => Promise.reject(error))
}

export const createWorkHourSettingAPI = async (data) => {
    return await axios('post', BASE, data, { loader: loaders.OVERLAY, successMessage: 'Work Hour Setting created successfully', server: microServices.DE_CORE })
        .then(data => data, error => Promise.reject(error))
}

export const updateWorkHourSettingAPI = async (id, data) => {
    return await axios('put', `${BASE}/${id}`, data, { loader: loaders.OVERLAY, successMessage: 'Work Hour Setting updated successfully', server: microServices.DE_CORE })
        .then(data => data, error => Promise.reject(error))
}

export const deactivateWorkHourSettingAPI = async (id) => {
    return await axios('delete', `${BASE}/${id}`, {}, { loader: loaders.OVERLAY, successMessage: 'Work Hour Setting deactivated successfully', server: microServices.DE_CORE })
        .then(data => data, error => Promise.reject(error))
}

export const assignWorkHourSettingAPI = async (data) => {
    return await axios('post', `${BASE}/assignment`, data, { loader: loaders.OVERLAY, successMessage: 'Work Hour Setting assigned successfully', server: microServices.DE_CORE })
        .then(data => data, error => Promise.reject(error))
}

export const getUserWorkHourAssignmentAPI = async (userId) => {
    return await axios('get', `${BASE}/assignment/user/${userId}`, {}, { loader: loaders.OVERLAY, server: microServices.DE_CORE })
        .then(data => data, error => Promise.reject(error))
}

export const getUserWorkHourAssignmentHistoryAPI = async (userId) => {
    return await axios('get', `${BASE}/assignment/history/${userId}`, {}, { loader: loaders.OVERLAY, server: microServices.DE_CORE })
        .then(data => data, error => Promise.reject(error))
}

export const deleteWorkHourAssignmentAPI = async (id) => {
    return await axios('delete', `${BASE}/assignment/${id}`, {}, { loader: loaders.OVERLAY, successMessage: 'Assignment deleted successfully', server: microServices.DE_CORE })
        .then(data => data, error => Promise.reject(error))
}
